export { BestCountry } from "./best_countries";
export { Mentors } from "./mentors";
export { UpcomingEvents } from "./upcoming_events";
export { WhyChoose } from "./why_choose";
export { WhyChooseHome } from "./why_choose_home";
export { StudyArea } from "./study_area";
export { AdmissionTabs } from "./admission";
export { BlogUpdate } from "./blog_update";
export { UnisearchStudent } from "./unisearch_student";
export { UnisearchUniversity } from "./unisearch_university";
export { UnisearchCommunity } from "./unisearch_community";
export { FindUniversity } from "./find_university";
